import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { formatCurrency } from 'utils/common';
import { LOADING, SUCCESS } from 'utils/store/fetch';
import LoadingIndicator from 'components/LoadingIndicator';
import { selectSurchargeOptOut } from 'containers/PrimoProfile/selectors';
import withPayment from '../../withPayment';
import styles from './styles.scss';

const CardSurcharges = ({ amount, method, isOptOut, payment }) => {
  const isCard = !!method?.cardType;
  const methodId = method?.id;
  const shouldRender = isCard && !isOptOut && methodId && amount > 0;

  useEffect(() => {
    if (shouldRender) payment.getSurcharge({ id: methodId, amount });
  }, [amount, methodId]);

  if (!shouldRender) return null;

  const isLoading = payment.surchargeFetchingStatus === LOADING;
  const hasLoaded = payment.surchargeFetchingStatus === SUCCESS;

  const cardFee = get(
    payment.surcharges,
    [`${amount}-${methodId}`, 'surchargeAmount'],
    0,
  );

  const total = get(
    payment.surcharges,
    [`${amount}-${methodId}`, 'grandTotal'],
    0,
  );

  return (
    <>
      {isLoading && <LoadingIndicator local />}
      {hasLoaded && (
        <>
          <div className={styles.line}>
            <div className={styles.greyLabel}>Credit card fee</div>
            <div className={`${styles.infoTitle} ${styles.greyLabel}`}>
              {formatCurrency(cardFee, '$0.00')}
            </div>
          </div>
          <div className={styles.line}>
            <div className={styles.greyLabel}>Total</div>
            <div className={`${styles.infoTitle} ${styles.totalLabel}`}>
              {formatCurrency(total, '$0.00')}
            </div>
          </div>
        </>
      )}
    </>
  );
};

CardSurcharges.propTypes = {
  amount: PropTypes.number,
  method: PropTypes.object,
  isOptOut: PropTypes.bool,
  payment: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isOptOut: selectSurchargeOptOut()(state),
});

export default compose(withPayment, connect(mapStateToProps))(CardSurcharges);
